/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData model module.
 * @module model/EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData
 * @version 1.0
 */
class EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData {
    /**
     * Constructs a new <code>EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData</code>.
     * @alias module:model/EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData
     */
    constructor() { 
        
        EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData} The populated <code>EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData();

            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('invCode')) {
                obj['invCode'] = ApiClient.convertToType(data['invCode'], 'String');
            }
            if (data.hasOwnProperty('codeEntryReward')) {
                obj['codeEntryReward'] = ApiClient.convertToType(data['codeEntryReward'], 'Number');
            }
            if (data.hasOwnProperty('buyerReward')) {
                obj['buyerReward'] = ApiClient.convertToType(data['buyerReward'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['invCode'] && !(typeof data['invCode'] === 'string' || data['invCode'] instanceof String)) {
            throw new Error("Expected the field `invCode` to be a primitive type in the JSON string but got " + data['invCode']);
        }

        return true;
    }


}



/**
 * @member {String} email
 */
EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData.prototype['email'] = undefined;

/**
 * @member {Number} accountNo
 */
EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData.prototype['accountNo'] = undefined;

/**
 * @member {String} invCode
 */
EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData.prototype['invCode'] = undefined;

/**
 * @member {Number} codeEntryReward
 */
EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData.prototype['codeEntryReward'] = undefined;

/**
 * @member {Number} buyerReward
 */
EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData.prototype['buyerReward'] = undefined;






export default EventsControllerDtoEventInvitationPartnerRewardListEventInvitationPartnerRewardListData;

